/*
 * File: /src/components/UIComponents/SearchPlugin/index.js
 * Created Date: Sunday May 2nd 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 2nd May 2021 7:23:28 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import Spotlight from './Spotlight.vue';

const GlobalSearchPlugin = {
  install(app, options) {
    app.component('s2-spotlight', Spotlight);
  }
};

export default GlobalSearchPlugin;
